"use strict";
/**
 * Marks a text with HTML tags
 *
 * @param {string} text The unmarked text.
 * @returns {string} The marked text.
 */

module.exports = function (text) {
  return "<yoastmark class='yoast-text-mark'>" + text + "</yoastmark>";
};
//# sourceMappingURL=addMark.js.map
//# sourceMappingURL=addMark.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/markers/addMark.js
// module id = 33
// module chunks = 0